import { render } from "./CreateButton.vue?vue&type=template&id=16622dd2&scoped=true"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"

import "./CreateButton.vue?vue&type=style&index=0&id=16622dd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16622dd2"]])

export default __exports__